import {fetchApi, Service } from "./restService";
import { v4 as uuidv4 } from 'uuid';

const addDashboard = (data) => {

    const url = 'dashboard';
    const method = 'POST';
    const body = data;

    return fetchApi(url, method, body)
        .then(response => response);
};

const getEntityType = () => {

    const url = 'entityView/types';
    const method = 'GET';
    const body = null;

    return fetchApi(url, method, body)
        .then(response => response);
};

const getEntitiesByType = (type) => {

    const url = 'tenant/entityViews?pageSize=100&page=0&textSearch=&type=' + type;
    const method = 'GET';
    const body = null;

    return fetchApi(url, method, body)
        .then(response => response);
};

const addEntityAliases = (data, dashboard) => {

    let entityuuid = uuidv4();

    const url = 'dashboard';
    const method = 'POST';
    const body = '{"id": {"entityType": "DASHBOARD", ' +
        '"id": "' + dashboard.id.id +'" },' +
        '"title": "' + dashboard.title +'",' +
        '"configuration": { ' +
        '"description":"' + dashboard.configuration.description + '",'+
        '"entityAliases": {"'+ entityuuid +'": {' +
        '"id": "'+ entityuuid +'",' +
        '"alias": "Terrain", "filter": { ' +
        '"type": "entityViewType", ' +
        '"resolveMultiple": true, ' +
        '"entityViewType": "", ' +
        '"entityViewNameFilter": "" }}}},' +
        ' "name": "' + dashboard.name +'"}';


    return fetchApi(url, method, body)
        .then(response => response);
};

class DashboardService extends Service {
    
    addDashboard = (data) => {

        const url = 'dashboard';
        const body = data;
    
        return this.POST(url, body)
            .then(response => response);
    };

    assignDashboardToCustomer = (dashboardId, customerIds) => {
        const url = `dashboard/${dashboardId}/customers`;
        let body = customerIds;
        return this.POST(url, JSON.stringify(body))
            .then(response => response);
    };
    
    getEntityType = () => {
            const url = 'entityView/types';

        return this.GET(url)
            .then(response => response);
    };
    
    getEntitiesByType = (type) => {
        const url = 'tenant/entityViews?limit=100&textSearch=&type=' + type;
    
        return this.GET(url)
            .then(response => response);
    };

    getEntitiesByText = (text) => {

        const url = 'tenant/entityViews?pageSize=100&page=0&textSearch=' + text;

        return this.GET(url)
            .then(response => response);
    };
    
    addEntityAliases = (data, dashboard) => {
    
        let entityuuid = uuidv4();
    
        const url = 'dashboard';
        const body = '{"id": {"entityType": "DASHBOARD", ' +
            '"id": "' + dashboard.id.id +'" },' +
            '"title": "' + dashboard.title +'",' +
            '"configuration": { ' +
            '"description":"' + dashboard.configuration.description + '",'+
            '"entityAliases": {"'+ entityuuid +'": {' +
            '"id": "'+ entityuuid +'",' +
            '"alias": "Terrain", "filter": { ' +
            '"type": "entityViewType", ' +
            '"resolveMultiple": true, ' +
            '"entityViewType": "", ' +
            '"entityViewNameFilter": "" }}}},' +
            ' "name": "' + dashboard.name +'"}';
    
    
        return this.POST(url, body)
            .then(response => response);
    };

    getDashboards = ()=> {
        const url = 'tenant/dashboards?pageSize=40&page=0&textSearch=';

        return this.GET(url)
            .then(response => response);
    }
}

export default DashboardService;
export {
    DashboardService,
    addDashboard,
    getEntityType,
    getEntitiesByType,
    addEntityAliases
}
